import { ToolkitListingID, ToolkitProperty, getToolkitListingID } from '@aloft/toolkit-shared';

import { runSearch } from './runSearch.ts';
import { toolkitPropertyToMatchProperty } from './toolkitPropertyToMatchProperty.ts';
import { DifferenceCriteria, MatchCriteria, MatchProperty, RunMatchSearchResult } from './types.ts';

function getPropRecords({
  getPartitionKey,
  dataset,
  allowAnyMls = false,
}: {
  dataset: ToolkitProperty[];
  getPartitionKey?: (prop: ToolkitProperty) => string | undefined;
  allowAnyMls?: boolean;
}): [Record<ToolkitListingID, ToolkitProperty>, Record<ToolkitListingID, MatchProperty>] {
  const propsByListingID: Record<ToolkitListingID, ToolkitProperty> = {};
  const matchPropsByListingID: Record<ToolkitListingID, MatchProperty> = {};

  for (const prop of dataset) {
    const listingID = getToolkitListingID(prop, allowAnyMls);

    if (listingID === undefined) continue;
    if (prop.listingStatus !== 'SettledSale') continue;

    propsByListingID[listingID] = prop;
    matchPropsByListingID[listingID] = {
      ...toolkitPropertyToMatchProperty(prop),
      partitionKey: getPartitionKey?.(prop) || undefined,
    };
  }

  return [propsByListingID, matchPropsByListingID];
}

export function runMatchSearch({
  dataset,
  difference,
  match,
  getPartitionKey,
  allowAnyMls = false,
}: {
  dataset: ToolkitProperty[];
  difference: DifferenceCriteria;
  match: MatchCriteria;
  getPartitionKey?: (prop: ToolkitProperty) => string | undefined;
  allowAnyMls?: boolean;
}): RunMatchSearchResult {
  const [propsByListingID, matchPropsByListingID] = getPropRecords({
    dataset,
    getPartitionKey,
    allowAnyMls,
  });

  const output = runSearch({
    difference,
    match,
    properties: matchPropsByListingID,
  });

  return { output, propsByListingID };
}
